// Libraries
import { observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

export class PlygeneStandardModel extends ModelBase<PlygeneStandardModel, PlygenStandardModelDTO> {
    constructor() {
        super();
    }

    // #region Model Properties

    @observable
    public gutterLengthMeterage: number = 0;

    @observable
    public girth: number = 0;

    // #region Model Properties

    public fromDto(model: PlygenStandardModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): PlygenStandardModelDTO {
        return {
            girth: this.girth,
            gutterLengthMeterage: this.gutterLengthMeterage,
            version: 2,
        };
    }
}

export interface PlygenStandardModelDTO {
    girth: number;
    gutterLengthMeterage: number;
    version: number;
}
